// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_k6-0";